import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export const isMobile = (pageContext?: WpsRuntime.atv.wps.PageContextModelProps) =>
  Boolean(pageContext.formFactor === 'Phone')

export const isPhablet = (pageContext?: WpsRuntime.atv.wps.PageContextModelProps) =>
  Boolean(pageContext.formFactor !== 'Desktop')
